import React, { useEffect, useState, useCallback } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { SERVER_URL } from "../../../constants.js";
import MissingFlightsTable from "../../Transfers/jsx/tables/MissingTransfersTable.jsx";
import StudentsMissingStayData from "./StudentsMissingStayData.js";
import StudentsIncompleteBookings from "./StudentsIncompleteBookings.js";
import "../Residents.css";
import dayjs from "dayjs";
import StudentsIncompleteActivities from "./StudentsIncompleteActivities.js";
import useMissingTransfers from "../../shared utils/UseMissingTransfers.js";

export default function FlightsAndStudentData({
    handleSelectStudent,
    yearSelected,
    refreshTrigger,
    campuses,
}) {
    const [value, setValue] = React.useState("1");
    const [flights, setFlights] = useState([]);
    const [studentsMissingData, setStudentsMissingData] = useState([]);
    const [lastUpdate, setLastUpdate] = useState("");
    const [incompleteBookings, setIncompleteBookings] = useState([]);
    const [incompleteActivities, setIncompleteActivities] = useState([]);
    const { missingFlights, internalTransfers, loading, refetch } = useMissingTransfers(yearSelected);


    const fetchIncompleteBookings = useCallback(() => {
        console.log("triggered fetch incomplete bookings: " + yearSelected);
        console.log("triggered fetch incomplete bookings: " + refreshTrigger);
        const token = sessionStorage.getItem("bearer");
        fetch(`${SERVER_URL}api/IncompleteBookingsYear/0/${yearSelected}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                if (response.status === 204) {
                    return [];
                } else if (response.ok) {
                    return response.json();
                } else {
                    throw new Error("Failed to fetch incomplete bookings");
                }
            })
            .then((data) => {
                setIncompleteBookings(data.length > 0 ? [...data] : []); // Ensure a new array reference
            })
            .catch((err) => console.error(err));
    }, [yearSelected, refreshTrigger]); // Add any dependencies needed

    const fetchIncompleteActivities = useCallback(() => {
        console.log("triggered fetch incomplete activities: " + yearSelected);
        console.log("triggered fetch incomplete bookings: " + refreshTrigger);

        const token = sessionStorage.getItem("bearer");
        fetch(`${SERVER_URL}api/IncompleteBookingsYear/1/${yearSelected}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                if (response.status === 204) {
                    return [];
                } else if (response.ok) {
                    return response.json();
                } else {
                    throw new Error("Failed to fetch incomplete activities");
                }
            })
            .then((data) => {
                //console.log("Fetched incomplete activities:", data);
                setIncompleteActivities(data.length > 0 ? [...data] : []); // Ensure a new array reference
            })
            .catch((err) => console.error(err));
    }, [yearSelected, refreshTrigger]);

    useEffect(() => {
        console.log(`Refresh Triggered: ${yearSelected} or ${refreshTrigger}`);
        fetchIncompleteBookings();
        fetchIncompleteActivities();
    }, [
        yearSelected,
        refreshTrigger,
        fetchIncompleteBookings,
        fetchIncompleteActivities,
    ]);

    useEffect(() => {
        console.log("Triggered useMissingTransfers refetch");
        refetch();
    }, [yearSelected, refreshTrigger, refetch]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    // fetch flights for TODAY
    const fetchArrivalsOnDate = useCallback(
        (updateExisting = true) => {
            const today = dayjs().format("YYYY-MM-DD");
            console.log(
                `Fetching arrivals for ${today} [updateExisting=${updateExisting}]`
            );
            const token = sessionStorage.getItem("bearer");
            fetch(
                `${SERVER_URL}api/flights/arrivals` +
                    `?date=${today}` +
                    `&updateExisting=${updateExisting}`,
                { headers: { Authorization: `Bearer ${token}` } }
            )
                .then((res) => {
                    if (res.status === 204) return {};
                    if (!res.ok) throw new Error("Failed to fetch arrivals");
                    return res.json();
                })
                .then((data) => {
                    sessionStorage.setItem("flights", JSON.stringify(data));
                    setFlights(data);
                })
                .catch(console.error);
        },
        [refreshTrigger]
    );

    useEffect(() => {
        console.log("Flights state updated:", flights);
    }, [flights]);

    useEffect(() => {
        fetchArrivalsOnDate();
    }, [fetchArrivalsOnDate]);

    // hourly refresh + timestamp
    useEffect(() => {
        const interval = setInterval(() => {
            fetchArrivalsOnDate(/* updateExisting= */ true);
            setLastUpdate(dayjs().format("L LT"));
        }, 60 * 60 * 1000);
        return () => clearInterval(interval);
    }, [fetchArrivalsOnDate]);

    const fetchStudentsMissingData = useCallback(() => {
  const token = sessionStorage.getItem("bearer");
  fetch(`${SERVER_URL}api/studentsWithoutStays`, {
      headers: { Authorization: `Bearer ${token}` },
  })
      .then((response) => {
          if (response.status === 204) {
              return [];
          } else if (response.ok) {
              return response.json();
          } else {
              throw new Error("Failed to fetch Students Missing Data");
          }
      })
      .then((data) => {
          sessionStorage.setItem(
              "studentsMissingData",
              JSON.stringify(data)
          );
          console.log("studentsMissingData:", data);
          setStudentsMissingData(data);
      })
      .catch((err) => console.error(err));
}, [refreshTrigger]); // depends on refreshTrigger so it changes

useEffect(() => {
  fetchStudentsMissingData();
}, [fetchStudentsMissingData]);


    return (
        <Box
            sx={{
                width: "100%",
                typography: "body1",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <TabContext
                sx={{
                    width: "100%",
                    typography: "body1",
                    justifyContent: "center",
                    alignItems: "center",
                }}
                value={value}
            >
                <Box
                    display="flex"
                    justifyContent="center"
                    width="100%"
                    sx={{ borderBottom: 1, borderColor: "divider" }}
                >
                    <TabList
                        variant="scrollable"
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        onChange={handleChange}
                        aria-label="Tabs"
                    >
                        <Tab
                            label="Students Without Stay Data"
                            value="1"
                            sx={{
                                flexGrow: 0.5,
                                justifyContent: "center",
                                border: 1,
                                borderRadius: 1,
                                mr: 0.5,
                            }}
                        />
                        <Tab
                            label="Students With Incomplete Bookings"
                            value="2"
                            sx={{
                                flexGrow: 0.5,
                                justifyContent: "center",
                                border: 1,
                                borderRadius: 1,
                                mr: 0.5,
                            }}
                        />
                        <Tab
                            label="Students With Incomplete Activities"
                            value="3"
                            sx={{
                                flexGrow: 0.5,
                                justifyContent: "center",
                                border: 1,
                                borderRadius: 1,
                                mr: 0.5,
                            }}
                        />
                        <Tab
                            label="Students Missing Flight Data"
                            value="5"
                            sx={{
                                flexGrow: 0.5,
                                justifyContent: "center",
                                border: 1,
                                borderRadius: 1,
                                mr: 0.5,
                            }}
                        />
                    </TabList>
                </Box>
                <TabPanel value="1">
                    <StudentsMissingStayData
                        mData={studentsMissingData}
                        handleSelectStudent={handleSelectStudent}
                    />
                </TabPanel>
                <TabPanel value="2">
                    <StudentsIncompleteBookings
                        mData={incompleteBookings}
                        handleSelectStudent={handleSelectStudent}
                    />
                </TabPanel>
                <TabPanel value="3">
                    <StudentsIncompleteActivities
                        mData={incompleteActivities}
                        handleSelectStudent={handleSelectStudent}
                    />
                </TabPanel>
                <TabPanel value="5">
                    <MissingFlightsTable
                        mFlights={missingFlights}
                        internalTransfers={internalTransfers}
                        handleSelectStudent={handleSelectStudent}
                        refreshData={refetch} 
                        campuses={campuses}
                    />
                </TabPanel>
            </TabContext>
        </Box>
    );
}
